import { useState } from "react";

export const useCheckbox = () => {
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());

  const toggleCheckbox = (id: number) => {
    setSelectedIds((prevSelectedIds) => {
      const newSelectedIds = new Set(prevSelectedIds);
      if (newSelectedIds.has(id)) {
        newSelectedIds.delete(id);
      } else {
        newSelectedIds.add(id);
      }
      return newSelectedIds;
    });
  };

  const CleanSelectIds = () => {
    setSelectedIds(new Set());
  };

  return {
    setSelectedIds,
    selectedIds: Array.from(selectedIds),
    toggleCheckbox,
    CleanSelectIds
  };
};
